// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/AtmlHero';
import Intro from '../components/AtmlIntro';
import Stats from '../components/AtmlCEO';
import Footer from '../components/Footer';

function AkijTextileMills() {
  return (
    <>
      <Intro />
      <Hero />
      <Stats />
      <Footer />
    </>
  );
}

export default AkijTextileMills;
